var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWarranty(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "80px",
    height: "80px",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "main_menu/warranty") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "main_menu/warranty",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(10.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-26",
    fill: "#FFFFFF",
    points: "0 57 40 57 40 0 0 0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,10 L7,7 L33,7 L33,10 L7,10 Z M7,17 L7,14 L33,14 L33,17 L7,17 Z M7,24 L7,21 L33,21 L33,24 L7,24 Z M7,31 L7,28 L33,28 L33,31 L7,31 Z",
    id: "Combined-Shape",
    fill: "#777A80"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-32",
    fill: "#00ABE3",
    points: "28.0293 46.1421 31.5653 35.5361 38.6353 42.6061"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.7275,51.2773 L4.2955,49.3243 C9.2155,48.2363 10.4455,39.5153 10.7055,36.8673 L12.6915,36.8363 C13.1225,40.1383 13.6175,43.5403 13.9895,46.0163 L15.7075,41.5963 L17.6145,41.7363 L18.8815,47.2853 L20.9985,42.7413 L22.8895,42.9953 C23.2945,45.3633 24.0465,47.7583 24.4985,48.1223 C24.9465,48.3633 25.3215,48.5653 26.6045,46.9083 L28.1865,48.1313 C27.4305,49.1093 25.8575,51.1383 23.5135,49.8613 C22.6525,49.3913 22.0135,47.8633 21.5635,46.2643 L19.4625,50.7753 L17.5815,50.5753 L16.3905,45.3593 L14.4985,50.2243 L12.5795,50.0183 C12.5715,49.9743 12.0975,46.9773 11.5405,43.1193 C10.4525,46.7493 8.4395,50.4573 4.7275,51.2773",
    id: "Fill-34",
    fill: "#135396"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-31",
    fill: "#167EC4",
    points: "38.6143 42.585 31.5653 35.536 55.6063 11.494 62.6563 18.543"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-33",
    fill: "#00ABE3",
    points: "61.9230906 23.5146 52.1121007 14.3226 50.6028818 15.7366 59.6592623 24.2216 46.8277 36.2426 48.3369189 37.6566 62.6777 24.2216"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarranty);
export default __webpack_public_path__ + "static/media/warranty.c298b1724ce81480c942451c872bd99f.svg";
export { ForwardRef as ReactComponent };